import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/clips";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100" id="faq">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1fr_1.4fr] lg:gap-14">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="关于爆料片段，你可能想问"
            description="如果这里没有答案，直接写信给我们，编辑会逐条回复。"
          />
          <div className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-question-answer-line text-lg" />
            </span>
            <p className="font-body text-sm leading-relaxed text-foreground-600">
              想提交线索或纠正片段信息？
              <br />
              邮箱：clip@baoliaoxianchang.com
            </p>
          </div>
        </div>

        <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.question}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {item.question}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="px-5 pb-5 font-body text-sm leading-relaxed text-foreground-600">
                    {item.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}